import { EnvironmentName } from './models/app-config.model';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LayoutModule } from '@angular/cdk/layout';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
// Angular stuff
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { AngularSplitModule } from 'angular-split';
// EURO_N stuff
import { NewmiModule } from 'newmi-angular';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { ChartsModule } from 'ng2-charts';
import { NgxAudioPlayerModule } from 'ngx-audio-player';
import { ColorSketchModule } from 'ngx-color/sketch';
import { IConfig, NgxMaskModule } from 'ngx-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FlowPlayerComponent } from 'src/core/app/aro/components/videos/players/flow/flow-player.Component';
import { IframeVideoPlayerComponent } from 'src/core/app/aro/components/videos/players/iframe/iframe-video-player';
import { AroSensorTabDetailsComponent } from './../../app/aro/aro-sensor-tab-details.component';
import { AlertListComponent } from './alert-list/alert-list.component';
import { AlertPolygonDialogComponent } from './alert-polygon/alert-polygon.component';
import { AnalysisBoardComponent } from './analysisBoard/analysisBoard.component';
import { AppConfig } from './app.config';
import { AroAngularTrackCoreComponent } from './aro/aro-angularTrack-core.component';
import { AroPlotCoreComponent } from './aro/aro-plot-core.component';
import { AroSensorCoreComponent } from './aro/aro-sensor-core.component';
import { AroTableComponent } from './aro/aro-table.component';
import { AroTrackCoreComponent } from './aro/aro-track-core.component';
import { CoordsComponent } from './aro/components/coords/coords.component';
import { DynamicsComponent } from './aro/components/dynamics/dynamics.component';
import { EqualizerAnimationComponent } from './aro/components/equalizerAnimation/equalizerAnimation.component';
import { JWPlayerOverlayComponent } from './aro/components/jwplayer/jwplayer-overlay.component';
import { JWPlayerComponent } from './aro/components/jwplayer/jwplayer.component';
import { AmplitudeImageComponent } from './aro/components/miniImages/amplitudeImage/amplitudeImage.component';
import { ClockImageComponent } from './aro/components/miniImages/clockImage/clockImage.component';
import { HighFreqImageComponent } from './aro/components/miniImages/frequencyImage/highFrequency/highFreqImage.component';
import { LowFreqImageComponent } from './aro/components/miniImages/frequencyImage/lowFrequency/lowFreqImage.component';
import { MidFreqImageComponent } from './aro/components/miniImages/frequencyImage/midFrequency/midFreqImage.component';
import { HeightImageComponent } from './aro/components/miniImages/heightImage/heightImage.component';
import { SensorImageComponent } from './aro/components/miniImages/sensorImage/sensorImage.component';
import { SoundPlayerComponent } from './aro/components/soundPlayer/soundPlayer.component';
import { SoundPlayerWindowComponent } from './aro/components/soundPlayer/soundPlayerWindow.component';
import { SpinningAnimationComponent } from './aro/components/spinningAnimation/spinningAnimation.component';
import { WowzaWebrtcPlayerComponent } from './aro/components/videos/players/wowza/wowza-webrtc-player.component';
import { ShowVideoPlayerComponent } from './aro/components/videos/show-video-player/show-video-player.component';
import { VideoPlayerSelectorComponent } from './aro/components/videos/video-player-selector/video-player-selector.component';
import { VideoPlayerWindowComponent } from './aro/components/videos/video-player-window/video-player-window.component';
import { BasicFieldNumberRComponent } from './aro/fields/basic-fields-numbers/basic-field-number-r.component';
import { BasicFieldNumberWComponent } from './aro/fields/basic-fields-numbers/basic-field-number-w.component';
import { BasicFieldNumberComponent } from './aro/fields/basic-fields-numbers/basic-field-number.component';
import { BasicFieldRComponent } from './aro/fields/basic-fields/basic-field-r.component';
import { BasicFieldWComponent } from './aro/fields/basic-fields/basic-field-w.component';
import { BasicFieldComponent } from './aro/fields/basic-fields/basic-field.component';
import { CheckBoxFieldComponent } from './aro/fields/checkbox-field/checkbox-field.component';
import { FieldNumberComponent } from './aro/fields/field-number.component';
import { FieldWriteNumberComponent } from './aro/fields/field-write-number.component';
import { FieldWriteComponent } from './aro/fields/field-write.component';
import { FieldComponent } from './aro/fields/field.component';
import { SwitchFieldComponent } from './aro/fields/switch-field.component';
import { DistanceFieldRComponent } from './aro/fields/unique-fields/distance-field/distance-field-r.component';
import { DistanceFieldWComponent } from './aro/fields/unique-fields/distance-field/distance-field-w.component';
import { DistanceFieldComponent } from './aro/fields/unique-fields/distance-field/distance-field.component';
import { LongDistanceFieldRComponent } from './aro/fields/unique-fields/distance-field/long-distances/long-distance-field-r.component';
import { LongDistanceFieldWComponent } from './aro/fields/unique-fields/distance-field/long-distances/long-distance-field-w.component';
import { LongDistanceFieldComponent } from './aro/fields/unique-fields/distance-field/long-distances/long-distance-field.component';
import { SpeedFieldRComponent } from './aro/fields/unique-fields/speed-field/speed-field-r.component';
import { SpeedFieldWComponent } from './aro/fields/unique-fields/speed-field/speed-field-w.component';
import { SpeedFieldComponent } from './aro/fields/unique-fields/speed-field/speed-field.component';
import { TrackCreatorComponent } from './aro/track-creator/track-creator.component';
import { BullsEyeComponent } from './bulls-eye/bulls-eye.component';
import { ChannelsComponent } from './channels/channels.component';
import { CardHeaderComponent } from './common/card-header/card-header.component';
import { ColorPickerComponent } from './common/color-picker/color-picker.component';
import { CrdtComponent } from './common/crdt/crdt.component';
import { DialogHeaderComponent } from './common/dialog-header/dialog-header.component';
import { InjectService } from './common/inject';
import { SessionService } from './common/session.service';
import { ConnectDialogComponent } from './connect/connect-dialog.component';
import { CoreAppComponent } from './core-app.component';
import { AcousticVectorSettingsComponent } from './display-filter/acvec-settings/acvec-settings.component';
import { DisplayFilterComponent } from './display-filter/display-filter.component';
import { MapsSettingsComponent } from './display-filter/maps-settings/maps-settings.component';
import { NaiNatSettingsComponent } from './display-filter/nainat-settings/nainat-settings.component';
import { PlotsSettingsComponent } from './display-filter/plots-settings/plots-settings.component';
import { SensorsSettingsComponent } from './display-filter/sensor-settings/sensors-settings.component';
import { TracksSettingsComponent } from './display-filter/tracks-settings/tracks-settings.component';
import { GlobalSettingsComponent } from './global-settings/global-settings.component';
import { IcmsSplitComponent } from './icms-split/icms-split.component';
import { JumpToComponent } from './jump-to/jump-to.component';
import { LoginComponent } from './login/login.component';
import { MainComponent } from './main/main.component';
import { CoordinatesPanelComponent } from './menu-bars/coord-panel.component';
import { FreeDrawBarComponent } from './menu-bars/free-draw-bar.component';
import { MapBarComponent } from './menu-bars/map-bar.component';
import { ObjectsMenuComponent } from './menu-bars/objects-menu.component';
import { ToolBarComponent } from './menu-bars/tool-bar.component';
import { UpperBarComponent } from './menu-bars/upper-bar.component';
import { AlertBoxComponent } from './msg-boxes/alert-box.component';
import { ConfirmBoxComponent } from './msg-boxes/confirm-box.component';
import { MsgBoxComponent } from './msg-boxes/msg-box.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { CameraListComponent } from './preset/camera-list/camera-list.component';
import { PresetComponent } from './preset/preset/preset.component';
// preset view stuff
import { PresetsComponent } from './preset/presets/presets.component';
import { SearchListComponent } from './preset/search-list/search-list.component';
import { VideoSplitComponent } from './preset/video-split/video-split.component';
import { SearchDialogComponent } from './search/search.component';
import { SecondScreenComponent } from './second-screen/second-screen.component';
import { AcousticSnippetComponent } from './sensor-window/sensor-snippet/acoustic-snippet.component';
import { SensorSnippetComponent } from './sensor-window/sensor-snippet/sensor-snippet.component';
import { VideoSnippetComponent } from './sensor-window/sensor-snippet/video-snippet.component';
import { SensorWindowComponent } from './sensor-window/sensor-window.component';
import { ShowErrorsDialogComponent } from './show-errors/show-errors.component';
import { PlaybackDialogComponent } from './side-navigation/playback-dialog/playback-dialog.component';
import { SideNavigationComponent } from './side-navigation/side-navigation.component';
import { SideViewComponent } from './side-view/side-view.component';
import { StatusBarComponent } from './status-bar/status-bar.component';
import { SubAreaComponent } from './sub-area/sub-area.component';
import { UserActionBodyComponent, UserActionComponent } from './user-action/user-action.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { VideoSelectComponent } from './video-player/video-select.component';
import { AuthGuard } from './auth-guard.service';
import { EnvironmentGuard } from './environment-guard.service';





const NG_MODULES = [
  BrowserModule,
  BrowserAnimationsModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  LayoutModule,
  FlexLayoutModule,
  MatToolbarModule,
  MatSidenavModule,
  MatIconModule,
  MatListModule,
  MatDividerModule,
  MatDialogModule,
  MatFormFieldModule,
  MatInputModule,
  MatGridListModule,
  MatCardModule,
  MatTabsModule,
  MatTableModule,
  MatSortModule,
  MatSliderModule,
  MatTooltipModule,
  MatMenuModule,
  MatRadioModule,
  MatExpansionModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSelectModule,
  FormsModule,
  ReactiveFormsModule,
  DragDropModule,
  NewmiModule,
  HttpClientModule,
  ScrollingModule,
  ChartsModule,
  HammerModule,
  VgCoreModule,
  VgControlsModule,
  VgOverlayPlayModule,
  RouterModule,
  PortalModule,
  ReactiveFormsModule,
  MatSelectModule,
  MatFormFieldModule,
  NgxMatSelectSearchModule,
  ColorSketchModule,
  NgxAudioPlayerModule,
  MatDatepickerModule,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  MatRippleModule,
  AngularSplitModule,
];

const CORE_COMPONENTS = [
  DialogHeaderComponent,
  CoreAppComponent,
  ObjectsMenuComponent,
  SideNavigationComponent,
  VideoPlayerComponent,
  VideoSelectComponent,
  UpperBarComponent,
  CoordinatesPanelComponent,
  IcmsSplitComponent,
  VideoSplitComponent,
  ShowVideoPlayerComponent,
  VideoPlayerSelectorComponent,
  ToolBarComponent,
  MapBarComponent,
  FreeDrawBarComponent,
  SearchDialogComponent,
  ShowErrorsDialogComponent,
  ChannelsComponent,
  AnalysisBoardComponent,
  AlertPolygonDialogComponent,
  ConnectDialogComponent,
  GlobalSettingsComponent,
  CardHeaderComponent,
  MsgBoxComponent,
  AlertBoxComponent,
  SubAreaComponent,
  SideViewComponent,
  MapsSettingsComponent,
  SensorsSettingsComponent,
  PlotsSettingsComponent,
  AcousticVectorSettingsComponent,
  NaiNatSettingsComponent,
  TracksSettingsComponent,
  ConfirmBoxComponent,
  DisplayFilterComponent,
  UserActionComponent,
  UserActionBodyComponent,
  AroTrackCoreComponent,
  AroPlotCoreComponent,
  AroTableComponent,
  TrackCreatorComponent,
  // ExternalIpComponent,
  LoginComponent,
  MainComponent,
  AlertListComponent,
  PresetsComponent,
  PresetComponent,
  NotFoundComponent,
  StatusBarComponent,
  ColorPickerComponent,
  SecondScreenComponent,
  JumpToComponent,
  CrdtComponent,
  CoordsComponent,
  DynamicsComponent,
  BullsEyeComponent,
  FieldComponent,
  SwitchFieldComponent,
  FieldWriteComponent,
  FieldWriteNumberComponent,
  FieldNumberComponent,
  BasicFieldComponent,
  BasicFieldRComponent,
  BasicFieldWComponent,
  BasicFieldNumberComponent,
  BasicFieldNumberRComponent,
  BasicFieldNumberWComponent,
  AroSensorTabDetailsComponent,
  DistanceFieldRComponent,
  DistanceFieldWComponent,
  DistanceFieldComponent,
  CheckBoxFieldComponent,
  SpeedFieldRComponent,
  SpeedFieldWComponent,
  SpeedFieldComponent,
  LongDistanceFieldRComponent,
  LongDistanceFieldWComponent,
  LongDistanceFieldComponent,
  SensorWindowComponent,
  SensorSnippetComponent,
  AcousticSnippetComponent,
  VideoSnippetComponent,
  SoundPlayerComponent,
  SpinningAnimationComponent,
  EqualizerAnimationComponent,
  SoundPlayerWindowComponent,
  AroAngularTrackCoreComponent,
  PlaybackDialogComponent,
  SensorImageComponent,
  ClockImageComponent,
  HeightImageComponent,
  AmplitudeImageComponent,
  LowFreqImageComponent,
  MidFreqImageComponent,
  HighFreqImageComponent,
  JWPlayerComponent,
  JWPlayerOverlayComponent,
  VideoPlayerWindowComponent,
  IframeVideoPlayerComponent,
  FlowPlayerComponent,
  CameraListComponent,
  SearchListComponent,
];

const CORE_ENTRY_COMPONENTS = [
  SearchDialogComponent,
  ShowErrorsDialogComponent,
  ChannelsComponent,
  AnalysisBoardComponent,
  AlertPolygonDialogComponent,
  ConnectDialogComponent,
  CoordinatesPanelComponent,
  IcmsSplitComponent,
  VideoSplitComponent,
  ShowVideoPlayerComponent,
  VideoPlayerSelectorComponent,
  ToolBarComponent,
  MapBarComponent,
  FreeDrawBarComponent,
  ObjectsMenuComponent,
  UserActionComponent,
  UserActionBodyComponent,
  MsgBoxComponent,
  AlertBoxComponent,
  SubAreaComponent,
  SideViewComponent,
  MapsSettingsComponent,
  SensorsSettingsComponent,
  AcousticVectorSettingsComponent,
  NaiNatSettingsComponent,
  PlotsSettingsComponent,
  TracksSettingsComponent,
  ConfirmBoxComponent,
  DisplayFilterComponent,
  GlobalSettingsComponent,
  UpperBarComponent,
  VideoPlayerComponent,
  VideoSelectComponent,
];


// Allow main page activation only when session is logged in


const routes: Routes =
  [
    {
      path: SessionService.MAIN_PATH,
      component: MainComponent,
      canActivate: [AuthGuard]
    },
    {
      path: SessionService.LOGIN_PATH,
      component: LoginComponent,
      canActivate: [EnvironmentGuard]
    },
    // tbd-second-screen
    /*{
      path: 'second',
      component: SecondScreenComponent
    },*/
    {
      path: '',
      redirectTo: SessionService.LOGIN_PATH,
      pathMatch: 'full'
    },
    {
      path: '**',
      component: NotFoundComponent
    }
  ];

// ngx-mask
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

export function initializeApp(appConfig: AppConfig): () => Promise<void> {
  return () => appConfig.load();
}

@NgModule({
  imports: [
    CommonModule,
    NG_MODULES,
    RouterModule.forRoot(routes, { useHash: true }),
    NgxMaskModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  declarations: [
    CORE_COMPONENTS,
    AroSensorCoreComponent,
    AlertListComponent,
    WowzaWebrtcPlayerComponent,
    
    
    
  ],
  providers: [
    AppConfig,
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppConfig], multi: true },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 15000 } },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-GB' },
    MapBarComponent,
    FreeDrawBarComponent,
    UserActionComponent,
    AuthGuard,
    EnvironmentGuard
  ],
  entryComponents: [
    CORE_ENTRY_COMPONENTS,
  ],
  exports: [
    NG_MODULES,
    CORE_COMPONENTS,
    NewmiModule,
  ],
})
export class CoreModule {
  constructor(private inject: InjectService) { }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
